module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_4",
      "title": "Copyright"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('em', [_vm._v("InterVarsity Press"), _c('br'), _vm._v("\n  P.O. Box 1400,"), _c('br'), _vm._v("\n  Downers Grove, IL 60515-1426"), _c('br'), _vm._v("\n  World Wide Web:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.ivpress.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("www.ivpress.com")])]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Email:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:email%40ivpress.com?subject="
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("email@ivpress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('em', [_vm._v("©2013 by")]), _vm._v(" "), _c('em', [_vm._v("Edward Gilbreath")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('em', [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('em', [_vm._v("InterVarsity Press")]), _c('em', [_vm._v("®")]), _vm._v(" "), _c('em', [_vm._v("is the book-publishing division of InterVarsity Christian Fellowship/USA")]), _c('em', [_vm._v("®")]), _c('em', [_vm._v(", a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept., InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.intervarsity.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("www.intervarsity.org")])]), _c('em', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('em', [_vm._v("While all stories in this book are true, some names and identifying information in this book have been changed to protect the privacy of the individuals involved.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('em', [_vm._v("Quotes by Martin Luther King Jr. reprinted by arrangement with The Heirs to the Estate of Martin Luther King Jr., c/o Writers House as agent for the proprietor New York, NY. Copyright: 1962, 1963, 1964, 1965, Martin Luther King Jr. Copyright renewed 1986, 1991 Heirs of Martin Luther King Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('em', [_vm._v("Design: Cindy Kiple")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('em', [_vm._v("Images:"), _c('br'), _vm._v("\n  The March on Birmingham: The Granger Collection, NYC/ All rights reserved."), _c('br'), _vm._v("\n  Dr. Martin Luther King Jr.: The Granger Collection, NYC/ All rights reserved."), _c('br'), _vm._v("\n  Photo of Edward Gilbreath: Phil Marcelo")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('em', [_vm._v("ISBN 978-0-8308-8445-2 (digital)"), _c('br')]), _c('em', [_vm._v("ISBN 978-0-8308-3769-4 (print)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55681477","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 63
// module chunks = 0